import React, { Component } from 'react'
import Page from '../containers/page'

import { Container, Row, Col, Input } from 'reactstrap'

import Isvg from 'react-inlinesvg'

import FormBuilder from '../components/forms/modalFormBuilder'
import { required } from '../components/forms/validation'
import Search from '../components/search'
import { Link } from 'react-router-dom'

import ListBuilder from '../components/listBuilder'
import DeleteModal from '../components/deleteModal'
import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from '../helpers/linkHelper'
import { API_ENDPOINT } from '../constants'

import editIcon from '../assets/svg/edit.svg'
import garabageIcon from '../assets/svg/garabage.svg'
import userIcon from '../assets/svg/user-icon.svg'
import notification from '../assets/svg/notification.svg'
import profile from '../assets/svg/profile-image.svg'
import moreIcon from '../assets/svg/more.svg'
import closeIcon from '../assets/svg/x.svg'
import rightIcon from '../assets/svg/arrow-right.svg'
import map from '../assets/svg/map.svg'
import chart from '../assets/svg/chart.svg'

class Users extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            areas: [],
            total: 0,
            loading: true,
            newsData: [],
        }
    }

    get = () => {
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0)
        }

        this.get()
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState(
                {
                    loading: true,
                },
                () => {
                    this.get()
                }
            )
        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params
            state.sortField = field
            state.sortType = type
            this.setState({
                params: state,
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    [
                        { name: 'sortField', value: field },
                        { name: 'sortType', value: type },
                    ],
                    false
                )
            )
        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                obj[name] = value
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                obj[name] = value
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLink(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    name,
                    value,
                    restart
                )
            )
        }
    }

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    fields,
                    restart
                )
            )
        }
    }

    delete = (id) => {
        this.setState(
            {
                loading: true,
            },
            () => {
                fetch(API_ENDPOINT + '/data/category/' + id, {
                    method: 'DELETE',
                    headers: {
                        'content-type': 'application/json',
                        Authorization:
                            typeof localStorage !== 'undefined'
                                ? `Bearer ${localStorage.getItem('authToken')}`
                                : null,
                    },
                })
                    .then((res) => res.json())
                    .then((result) => {
                        this.get()
                    })
            }
        )
    }

    render() {
        let params = {}
        if (this.state.useState) {
            params = this.state.params
        } else {
            params = getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
            })
        }


        return (
            <div className='page'>
                <Container className='dashboard'>
                    <Row>
                        <Col lg='9'>
                            <Search updateParams={this.updateParams} />
                            <div className='panel'>
                                <div className='main-table-header'>
                                    <h5 className='component-header'>LIsta Kategorija</h5>
                                    <button className='add-news'>
                                        <Link to='/addCategory'>
                                            Dodaj kategoriju
                    </Link>
                                    </button>
                                </div>

                                <ListBuilder
                                    loading={this.state.loading && false}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={[
                                        {
                                            type: 'text', class: 'labelbam', name: 'categoryName', sortLabel: 'Po imenu', allowSort: true,
                                        },
                                        {
                                            type: 'list', itemName: 'subcategoryName', name: 'subcategories', allowSort: false, actions: []
                                        }
                                    ]}
                                    rawItems={this.state.items}
                                    items={


                                        this.state.items.map((item, idx) => {
                                            return {
                                                ...item,
                                                source: <div>
                                                    <Isvg src={userIcon} className='name-icon' />
                                                    {item.source}
                                                </div>,
                                                name: item.name
                                            }

                                        })

                                    }
                                    actions={[
                                        /*{
                                            type: 'functionAction',
                                            render: (item) => <Link to={
                                                `/addNews/${item._id}`
                                            }><Isvg src={editIcon} />
                                            </Link>,
                                        },*/
                                        {
                                            component: <Isvg src={garabageIcon} className className='edit-icon' />,
                                            onClick: (item) => this.setState({ deleteModal: item })
                                        },
                                    ]}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal._id); this.setState({ deleteModal: null }) }}
                                >
                                    Obrisi kategoriju <strong>{this.state.deleteModal && this.state.deleteModal.name}</strong>?
                  </DeleteModal>

                            </div>
                        </Col>
                        <Col lg='3'>

                            <div className='component notifications'>
                                <Isvg src={notification} />
                                <div className='profile'>
                                    <span className='name'>
                                        {this.props.uData.username}
                                    </span>
                                    <Isvg src={profile} className='profile-image' />
                                    <Isvg src={moreIcon} />
                                </div>
                            </div>

                            <div className='component customer-age'>
                                <h5 className='component-header'>Age of Customers</h5>
                                <select name='options'>
                                    <option>This month</option>
                                </select>
                                <select name='options'>
                                    <option>Stockholm</option>
                                </select>
                                <Isvg src={map} className='map' />
                                <div className='age-group'>
                                    <span>Age 18-24</span>
                                    <div class='bar bar-small'>
                                        <div class='bar-progress progress-small'></div>
                                    </div>
                                    <span className='bar-precent'>48%</span>
                                </div>
                                <div className='age-group'>
                                    <span>Age 25-34</span>
                                    <div class='bar bar-small'>
                                        <div class='bar-progress progress-small'></div>
                                    </div>
                                    <span className='bar-precent'>48%</span>
                                </div>
                                <div className='age-group'>
                                    <span>Age 34-44</span>
                                    <div class='bar bar-small'>
                                        <div class='bar-progress progress-small'></div>
                                    </div>
                                    <span className='bar-precent'>48%</span>
                                </div>
                                <div className='age-group'>
                                    <span>Age 45-55</span>
                                    <div class='bar bar-small'>
                                        <div class='bar-progress progress-small'></div>
                                    </div>
                                    <span className='bar-precent'>48%</span>
                                </div>
                                <div className='age-group'>
                                    <span>Age 55+</span>
                                    <div class='bar bar-small'>
                                        <div class='bar-progress progress-small'></div>
                                    </div>
                                    <span className='bar-precent'>48%</span>
                                </div>
                            </div>

                            <div className="box">
                                <div className="box-content">
                                    <h5>Customers</h5>
                                    <h3>5.859 $</h3>
                                </div>
                                <div className="box-image">
                                    <Isvg src={chart} />
                                    <h6>+ 4.5% last week</h6>
                                </div>
                            </div>

                            <div className="box">
                                <div className="box-content">
                                    <h5>Revenue</h5>
                                    <h3>24.483 $</h3>
                                </div>
                                <div className="box-image">
                                    <Isvg src={chart} />
                                    <h6>+ 15% last week</h6>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>

            </div>
        )
    }
}

export default Page(Users)
